import { navigate } from '@/app/router';
import type { PracticeSession } from '@/game/practiceSession';

/**
 * Debug mode's bar at the bottom of a level: drives the mission without speaking (development and
 * QA). Each action goes through the real coach and session, so what follows (feedback, cues,
 * letters, the codename stage, the report) is what a child would get.
 */
export function DebugBar({ session }: { session: PracticeSession }) {
  const actions: [string, () => void][] = [
    ['✓ Correct', () => void session.debugAttempt(0.95)],
    ['✗ Miss (w)', () => void session.debugAttempt(0.05, 'w')],
    ['✗ Miss (l)', () => void session.debugAttempt(0.05, 'l')],
    ['✗ Miss (distorted)', () => void session.debugAttempt(0.05)],
    ['≈ Near miss', () => void session.debugAttempt(0.25)],
    ['… Silence', () => void session.debugSilence()],
    ['? Show me how', () => void session.help()],
    ['⏹ End mission', () => void session.debugEnd()],
    [
      '⚙ Debug page',
      () => {
        void session.stopMic();
        navigate({ page: 'debug' });
      },
    ],
  ];
  return (
    <div
      role="toolbar"
      aria-label="Debug"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 50,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        justifyContent: 'center',
        padding: '4px 6px calc(4px + env(safe-area-inset-bottom))',
        background: 'rgb(0 0 0 / 0.78)',
        font: '12px system-ui',
      }}
    >
      {actions.map(([label, run]) => (
        <button
          key={label}
          type="button"
          onClick={run}
          style={{
            padding: '4px 8px',
            border: '1px solid #7fdcff',
            borderRadius: 6,
            background: '#071a45',
            color: '#fff',
            font: 'inherit',
            cursor: 'pointer',
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
